define('templates/helpers/priceFormat',["handlebars"], function( Handlebars ) {
  var priceFormat = function( context ) {
    if ( context == null ) {
      return "";
    }

    if (context % 1 != 0) {
      zeroRe  = /0+$/;
      context = context.toFixed(4).replace(/\./, ",");

      if(context.match(zeroRe)[0].length < 3) {
        return context.replace(zeroRe, "");
      }
      else {
        return context.substring(0, context.length - 2);
      }
    }
    else {
      var value = context.toString().split(/\./),
      thousands = value[0].split("").reverse().join("").match(/\d{1,3}/g).join(" ").split("").reverse().join(""),
      decimals = value[1];

      return thousands + (decimals ? "." + decimals : "");
    }
  };

  Handlebars.registerHelper("priceFormat", priceFormat);
  return priceFormat;
});
